import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { Chip, makeStyles, Theme, createStyles } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { IActiveFilter } from '@app/models';
import { removeActiveFilter, clearActiveFilters, resetState } from '@app/store/actions';
import { PasslyButton } from '..';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        margin: {
            margin: theme.spacing(0.5),
        },
    }),
);

export const Filters: React.SFC = (props) => {
    const { translation } = useTypedTranslation();
    const classes = useStyles();

    const activeFilters: IActiveFilter[] = useSelector((state: any) => state.listPageBar.activeFilters);
    const dispatch = useDispatch();

    const handleDelete = (filterToDelete: IActiveFilter) => () => {
        dispatch(removeActiveFilter(filterToDelete.name));
        dispatch(resetState());
    };

    const handleClearAll = () => () => {
        dispatch(clearActiveFilters());
        dispatch(resetState());
    };

    return (
        <section className='filters'>
            <div className='filters__list'>
                <div className='filters__header'>
                    {translation('FILTER_BY')}:
                </div>
                {props.children}
            </div>
            {activeFilters.length > 0 &&
                <div className='filters__filteredby'>
                    <div className='filters__header'>
                        {translation('FILTERED_BY')}:
                </div>
                    <div className='filters__active'>
                        {activeFilters.map((filter: IActiveFilter, index) => {
                            return (
                                <Chip
                                    key={index}
                                    label={filter.label}
                                    onDelete={handleDelete(filter)}
                                    className={classes.margin}
                                    size='small'
                                />
                            );
                        })}
                    </div>
                    <PasslyButton
                        variant='text'
                        color='primary'
                        className={classes.margin}
                        onClick={handleClearAll()}
                    >
                        {translation('CLEAR_ALL')}
                </PasslyButton>
                </div >
            }

        </section >
    );
};
